import { useState, useEffect } from "react";

// Helper function to get cart from localStorage
const getCartFromStorage = () => {
  if (typeof window !== 'undefined') {
    const storedCart = localStorage.getItem('cart');
    return storedCart ? JSON.parse(storedCart) : [];
  }
  return [];
};

// Custom hook to manage the cart state and operations
export const useCart = () => {
  const [cart, setCart] = useState(() => getCartFromStorage());

  // Sync with localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  }, [cart]);

  /* 1- Add an item to the cart */
  const addToCart = (item) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(cartItem => cartItem.id === item.id);
      if (existingItem) {
        return prevCart.map(cartItem =>
          cartItem.id === item.id 
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
      return [...prevCart, { ...item, quantity: 1 }];
    });
  };

  /* 2- Decrease item quantity */
  const removeFromCart = (item) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(cartItem => cartItem.id === item.id);
      if (!existingItem) return prevCart;
      
      if (existingItem.quantity === 1) {
        return prevCart.filter(cartItem => cartItem.id !== item.id);
      }
      return prevCart.map(cartItem =>
        cartItem.id === item.id
          ? { ...cartItem, quantity: cartItem.quantity - 1 }
          : cartItem
      );
    });
  };

  /* 3- Remove item completely */
  const removeCompletely = (item) => {
    setCart(prevCart => prevCart.filter(cartItem => cartItem.id !== item.id));
  };

  /* 4- Clear entire cart */
  const clearCart = () => {
    setCart([]);
  };

  // Calculate total items
  const getTotalItems = () => cart.reduce((total, item) => total + item.quantity, 0);

  // Calculate total price
  const getTotalPrice = () => cart.reduce(
    (total, item) => total + (item.price * item.quantity), 0
  );

  return {
    cart, 
    setCart,
    addToCart, 
    removeFromCart, 
    removeCompletely,
    clearCart,
    getTotalItems,
    getTotalPrice
  };
};